import { Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/chords/ErrorPage';

import { MyProfilePage } from './pages/MyProfilePage';

function Router() {
  return (
    <Routes>
      <Route index element={<MyProfilePage />} />

      <Route path="*" element={<ErrorPage type="notFoundPage" />} />
    </Routes>
  );
}

Router.displayName = 'MyProfileRouter';

export { Router };
